/**
 * @description
 * 获取点数余额与状态
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IBalanceInfo {
    is_creator: 0 | 1;
    is_show_live_umupoints: 0 | 1;
    live_free_times: number;
    enterprise_account?: {
        balance: number;
        account_status: 0 | 1;
        is_admin: 0 | 1;
    };
    personal_account: {
        balance: number;
        account_status: 0 | 1;
    };
}
export interface IInput {
    element_id: number;
}
export const getBalanceInfo = (data: IInput): Promise<IResponse<IBalanceInfo>> => {
    const api = Object.assign({}, Api.GET_BALANCE);
    return fetchData(api, data, { silent: true }).then((res: IResponse<IBalanceInfo>) => {
        return res;
    });
};

export const getBalanceInfoSync = fetchDataSync(getBalanceInfo);
